import { memo, useEffect, useMemo, useState } from "react";
import { toast } from "react-toastify";
import { Input } from "../../../../Components/AllInput/AllInput";
import ReactSelect from "../../../../Components/New/Select/ReactSelect";
import { ProjectTy } from "../../../../ReduxTool/Slice/Auth/types";
import { getTerrifData } from "../../../../ReduxTool/Slice/CommonReducers/CommonActions";
import { IallTypestate, ITariffType } from "../../../../ReduxTool/Slice/CommonReducers/types";
import { calcTariffRate, getCostBracket } from "../../../../ReduxTool/Slice/Consumer/ConsumerActions";
import { setCostBracketReset, setCountryName, setCreatedId, setFormProjectSetup, setMaxAllowedMonthlyUnitEmpty, setProjectName, setRegionName, setRoofDetailsError } from "../../../../ReduxTool/Slice/Consumer/ConsumerReducers";
import { setIsBuildingDrawn } from "../../../../ReduxTool/Slice/Map/MapReducer";
import { useAppDispatch, useAppSelector } from "../../../../ReduxTool/store/hooks";
import { GridTypeOption, RoofType, selectOptionType } from "../../../../Utils/Const";
import globalLayers from "../../../../Utils/CustomerMaps/Maps/GlobaLMap";
import { fetchCompleteAddress, fetchCountryNamefromLatLng, getCityFromCoordinates, getStateFromCoordinates } from "../../../../Utils/CustomerMaps/Maps/LazyloadMap";
import { getCurrencyLabel, containsInvalidChars, filterKeyIncludeArr, formatReactSelectOptions, getElementByIndex, isValidNumberIp, newgeneratedId, useDebounce } from "../../../../Utils/commonFunctions";
import { IconInfo1 } from "../../../../assests/icons/DrawerIcons";
import { Accordion } from "../NewSiteAnalyze";
import SolarReviewComponent from "../RoofAnalysisExtras/RoofDetailsExtras";
import { GetTarifByLatLong } from "./api";
import { blockKeys } from "../../../../Utils/_input/Input";
import ReactToolTip from "../../../../Components/InfoModal/ReactToolTip";
// import {} from '@/utils'

export const ROOF_TYPE_UTILIZATION_FACTOR: Record<string, number> = {
  "RCC Flat Roof": 0.70,
  "RCC Sloped Roof": 0.70,
  "Metal Roof": 0.90,
  "Tile Roof": 0.75,
  "BIPV Roof": 1.00,
  "Carpark Roof": 0.85,
} as const;


const MAX_UNIT_PER_KW = 165;
const MAX_MONTHLY_UNIT = 15000;
const MAX_ROOF_AREA = 50000;
const isResidentialCategory = (name: string) => /^(domestic|residential)\b/i.test(name.trim());
const MAXDCTOACCONVERTRATIO = 0.85; // 0.85 (85%) → safe & realistic {By chatgpt}

export const computeCapacity = (useableArea: number) => {
  const module = { length: 1.816, width: 1.068, stc: 560 }
  // const useableArea = (projectSetup?.useablearea || 0 > 0) ? +projectSetup?.useablearea?.toFixed(2) : +projectSetup?.totalroofarea?.toFixed(2)
  if (!useableArea) return 0;

  const moduleArea = module.length * module.width;
  const modulePower = module.stc;

  // Calculate number of modules and total capacity in kW
  const moduleNo = useableArea / moduleArea;
  const capacity = (moduleNo * modulePower) / 1000;

  return Math.round(capacity); // .toFixed(0) and parseInt is same as Math.round
};

export const getMaxConnectedLoad = (useableArea: number, totalRoofArea: number) => {
  const area = useableArea > 0 ? useableArea : totalRoofArea;
  if (!Number.isFinite(area) || area <= 0) return 0;
  return Math.round(computeCapacity(Number(area.toFixed(2))) * MAXDCTOACCONVERTRATIO);
};


export const validateNumberOnlyInput = (e: any) => {
  const key = e.key;
  // const isControlKey = (key === 'Backspace' || key === 'Delete' || key === 'ArrowLeft' || key === 'ArrowRight' || key === 'ArrowUp' || key === 'ArrowDown');
  const isControlKey = (key === 'Backspace' || key === 'Delete' || key === 'ArrowLeft' || key === 'ArrowRight');
  if (isControlKey) { return; }
  const isNumeric = /^[0-9]$/.test(key);
  if (isNumeric) { return; }
  e.preventDefault();
};

const RoofDetails = ({ isLoading, setIsLoading, step = 1, completedstep, }: { step?: number, completedstep?: number, isLoading?: boolean, setIsLoading?: (arg: boolean) => void, }) => {
  const dispatch = useAppDispatch();
  const { user } = useAppSelector(state => state.auth);
  const { roofAnalysis: { formDetails: { projectSetup: { lat, lng, address }, projectSetup, error, }, selected_project, isWithRoof, useableArea, obsArea, countryName, regionName } } = useAppSelector(state => state.consumerReducers);
  const { allDiscom, providertype, loading: isLoadingProvider } = useAppSelector((state) => state.commonReducers);
  const { user: { projects } } = useAppSelector(state => state.auth);
  const { polygonDrawn } = useAppSelector((state) => state.drawer);
  const { is3ddata } = useAppSelector((state) => state.mapref);
  const [rateDraft, setRateDraft] = useState<string | null>(null);
  const suggestedMaxLoad = useMemo(
    () => getMaxConnectedLoad(projectSetup.useablearea, projectSetup.totalroofarea),
    [projectSetup.useablearea, projectSetup.totalroofarea]
  );
  const isAboveSuggestedLoad = suggestedMaxLoad > 0 && Number(projectSetup.sanctionload) > suggestedMaxLoad;
  const [maxMonthlyUnit, setMaxMonthlyUnit] = useState(15000);
  const [electricRateLoading, setElectricRateLoading] = useState(false);
  const filteredProviderType = useMemo(() => projectSetup.sanctionload > 20
    ? providertype.filter(category => !isResidentialCategory(category.consumercategoryname || ""))
    : providertype, [projectSetup.sanctionload, providertype]);


  useEffect(() => {
    let maxallowedmonthlyunit = +(projectSetup.sanctionload) * MAX_UNIT_PER_KW
    if (maxallowedmonthlyunit < MAX_MONTHLY_UNIT) {
      setMaxMonthlyUnit(maxallowedmonthlyunit)
      if (+(projectSetup.monthlyunit!) > maxallowedmonthlyunit) {
        dispatch(setMaxAllowedMonthlyUnitEmpty())
      }
    } else {
      setMaxMonthlyUnit(MAX_MONTHLY_UNIT)
    }
    if (maxallowedmonthlyunit < +(projectSetup.monthlyunit!)) {
      dispatch(setMaxAllowedMonthlyUnitEmpty())
    }
    if (+(projectSetup.sanctionload) === 0) {
      dispatch(setMaxAllowedMonthlyUnitEmpty())
    }
  }, [projectSetup.sanctionload, projectSetup.monthlyunit, dispatch]);

  // Auto-select "Domestic" consumer category when not set and available in options
  useEffect(() => {
    // Do nothing if a project is already loaded or provider is not selected
    // console.log("consumer project setup    ==>.  ", projectSetup?.consumercategoryid)
    // console.log("Project status  ==>.  ", (selected_project?.projectstatus !== 1 && selected_project?.projectstatus !== 2))
    if (selected_project && !selected_project.projectid) return;
    if (!projectSetup?.providerid) return;
    if (projectSetup?.sanctionload > 20) {
      // dispatch(setRoofDetailsError({ ...error, ['sanctionload']: `sanction load must be less than 20 for domestic` }));
      return
    };

    // Only set default when the initial state is explicitly null
    const isUnset = projectSetup?.consumercategoryid === null && (selected_project?.consumer_projectstatus !== 2 && selected_project?.consumer_projectstatus !== 3);
    if (!isUnset) return;

    const domestic = providertype?.find((item) => (item.consumercategoryname || "").toLowerCase() === "domestic");
    if (!domestic) return;

    // GetTarifByLatLong(lat,lng)

    const newSetup = { ...projectSetup, consumercategoryid: { label: domestic.consumercategoryname, value: domestic.consumercategoryid } as selectOptionType, };
    dispatch(setFormProjectSetup(newSetup));
    // console.log("Errors ==>> ",error)
    // error in form   -->>.  {consumercategoryid: 'This field is required'}
    if (error?.consumercategoryid) {
      const { consumercategoryid, ...rest } = error; // removes the key
      dispatch(setRoofDetailsError(rest)); // rest has all other errors
    }

    if (newSetup.sanctionload && newSetup.providerid?.value) {
      debouncedGetElecticRate(newSetup.sanctionload, newSetup.providerid.value, domestic.consumercategoryid);
    }
  }, [providertype]);

  useEffect(() => {
    if (projectSetup.sanctionload <= 20 || !projectSetup.providerid?.value ||
      isLoadingProvider === "loading" || selected_project?.iscompleted) return;

    const selectedValue = projectSetup.consumercategoryid?.value;
    const onlyCategory = filteredProviderType.length === 1 ? filteredProviderType[0] : null;

    if (onlyCategory && selectedValue !== onlyCategory.consumercategoryid) {
      const nextCategory = { label: onlyCategory.consumercategoryname, value: onlyCategory.consumercategoryid } as selectOptionType;
      dispatch(setFormProjectSetup({ ...projectSetup, consumercategoryid: nextCategory, electricityrate: 0 }));
      if (error?.consumercategoryid) {
        const { consumercategoryid, ...remainingErrors } = error;
        dispatch(setRoofDetailsError(remainingErrors));
      }
      debouncedGetElecticRate(projectSetup.sanctionload, projectSetup.providerid.value, onlyCategory.consumercategoryid);
    } else if (selectedValue && !filteredProviderType.some(category => category.consumercategoryid === selectedValue)) {
      dispatch(setFormProjectSetup({ ...projectSetup, consumercategoryid: null, electricityrate: 0 }));
    }
  }, [filteredProviderType, projectSetup.sanctionload, projectSetup.providerid?.value,
    projectSetup.consumercategoryid?.value, isLoadingProvider, selected_project?.iscompleted]);

  const getElectricRate = async (providerid: string, sanctionload: number, consumercategoryid: string) => {
    setElectricRateLoading(true)
    if (providerid && sanctionload && consumercategoryid) {
      try {
        const reqBody = { sanctionload, providerid, consumercategoryid };
        let { meta: { requestStatus }, payload } = await dispatch(calcTariffRate(reqBody));

        if (requestStatus === "fulfilled" && payload) {
          if (payload > 0) updateErrorFields(["electricityrate", "consumercategoryid"]);
        }

      } catch (err: any) {
        console.log(err);
        toast.error("There was an issue to fetch electricity rate. Please try again later.", { autoClose: 7000 });
      }
      finally {
        setElectricRateLoading(false)
        // setIsLoading?.(false)
      }
    }
  };

  const debouncedGetElecticRate = useDebounce((sanctionload, providerid, consumercategoryid) => (sanctionload && providerid && consumercategoryid) && getElectricRate(providerid, sanctionload, consumercategoryid), 1000);
  const debouncedGetCostBracket = useDebounce((value: number) => dispatch(getCostBracket(value)), 300);

  const updateErrorFields = (fieldNames: string[]) => {
    let updatedErrors = { ...error };
    for (let fieldName of fieldNames) {
      if (updatedErrors[fieldName]) {
        delete updatedErrors[fieldName];
        updatedErrors = { ...updatedErrors };
      };
    }
    dispatch(setRoofDetailsError(updatedErrors));
  };

  const handleChange = async (props: any, selectedOption?: any) => {

    const target = props?.target ?? props;
    let { name, value, type, maxLength } = target;

    // const invalidCharPattern = /[eE+\-\s]/; // includes space
    // Only process type="number"
    if (type === "number") { // Check if the type string is "number"
      value = String(value)
      if (maxLength) {
        // Keep only digits
        const digitsOnly = value.replace(/\D/g, "");
        // Remove leading zeros
        const cleanedValue = digitsOnly.replace(/^0+/, "");
        // Enforce maxLength (uncommented if you want this active)
        if (cleanedValue.length > maxLength) {
          console.log("Input exceeds maxLength. Blocking entry.");
          return;
        }
        value = cleanedValue;
      }
      value = Number(value);
    }

    if (selectedOption) {
      name = selectedOption.name;
      value = props;
    };
    if (name === "electricityrate") {
      const raw = String(value);
      const next = (raw.startsWith(".") ? `0${raw}` : raw)
        .replace(/^0+(?=\d)/, "");

      const isOman = user.country_mstr?.alpha2code?.toUpperCase() === "OM";
      const maxLength = isOman ? 6 : 5;
      const validRate = isOman
        ? /^\d*(?:\.\d{0,3})?$/.test(next)
        : /^\d*(?:\.\d{0,2})?$/.test(next);

      if (next.length > maxLength || !validRate) return;

      setRateDraft(next);
      dispatch(setFormProjectSetup({
        ...projectSetup,
        electricityrate: next === "" ? NaN : Number(next),
      }));
      updateErrorFields(["electricityrate"]);
      return;
    }
    if (name === "totalroofarea" && (parseInt(value) > MAX_ROOF_AREA)) { return }
    if (name === "monthlyunit" && (parseInt(value) > MAX_MONTHLY_UNIT || containsInvalidChars(value) || parseInt(value) > maxMonthlyUnit)) { return }
    if (name === "monthlyunit") {
      const digitsOnly = value.replace(/\D/g, "");
      // Remove leading zeros
      value = digitsOnly.replace(/^0+/, "");
    }
    if (name === "sanctionload" && (!isValidNumberIp(String(value)) || String(value).length > 7) && value !== 0) { return }
    // if (name === "electricityrate" && (value.length > 5 || containsInvalidChars(value))) { return }
    if (name === 'monthlyunit') {
      // Ensure only numeric values with up to 2 decimal places or an empty value are allowed
      const numericPattern = /^(\d*\.?\d{0,2})?$/;
      if (!numericPattern.test(value)) {
        return; // Exit if input contains invalid characters
      }
      // debugger
      // Prevent multiple leading zeros
      let newValue = value;
      if (value.startsWith("0") && value.length >= 1 && value[1] !== ".") {
        value = newValue.replace(/^0+/, ""); // Replace multiple leading zeros with a single zero
      }
      // Add '0' prefix if the value starts with '.'
      if (value.startsWith(".") && !isNaN(parseFloat(value))) { value = "0" + value; }
    }
    let projectsetup = { ...projectSetup, [name]: value ?? props! };
    let errorFields = [name];
    // if (name === "projecttype") {
    //   let area = "0";
    //   if (projectSetup.totalroofarea) {
    //     if (value.value === "RCC Flat") {
    //       if (projectSetup.totalroofarea > 0) {area = (projectSetup.totalroofarea * 0.7).toString(); }
    //     }
    //     if (value.value === "Metal Sheet") {
    //       if (projectSetup.totalroofarea > 0) { area = (projectSetup.totalroofarea * 0.9).toString(); }
    //     }
    //     if (value.value === "Hybrid") {
    //       if (projectSetup.totalroofarea > 0) { area = projectSetup.totalroofarea.toString(); }
    //     }
    //     projectsetup.useablearea = parseFloat(area);
    //   };
    // }

    if (name === "totalroofarea" && projectSetup.projecttype) {
      const factor = ROOF_TYPE_UTILIZATION_FACTOR[projectSetup.projecttype.value as keyof typeof ROOF_TYPE_UTILIZATION_FACTOR] ?? 0;
      projectsetup.useablearea = Number(value) * factor;

    }

    if (name === "projecttype") {
      const total = projectSetup.totalroofarea ?? 0;

      if (total > 0) {
        const factor = ROOF_TYPE_UTILIZATION_FACTOR[value.value as keyof typeof ROOF_TYPE_UTILIZATION_FACTOR] ?? 0;
        projectsetup.useablearea = total * factor;
      } else {
        projectsetup.useablearea = 0;
      }
    }
    else if (name === 'sanctionload') {
      // const maxConnectedLoad = getMaxConnectedLoad(projectSetup.useablearea, projectSetup.totalroofarea);
      // // Keep the value the user entered so an invalid edit cannot silently retain the old load.
      // if (value > maxConnectedLoad) {
      //   dispatch(setFormProjectSetup(projectsetup));
      //   dispatch(setRoofDetailsError({
      //     ...error,
      //     sanctionload: `Connected load must be at most ${maxConnectedLoad} kW for this roof area`,
      //   }));
      //   return;
      // }
      if (value > 20 && isResidentialCategory(projectSetup.consumercategoryid?.label || "")) {
        projectsetup.consumercategoryid = null;
      }
      dispatch(setFormProjectSetup(projectsetup));
      if (!value) dispatch(setCostBracketReset("0"));
      updateErrorFields(["sanctionload"]);
      if (value) debouncedGetElecticRate(projectsetup.sanctionload, projectsetup.providerid?.value, projectsetup.consumercategoryid?.value);
      return;
    } else if (name === "providerid") {
      dispatch(getTerrifData(value.value));
      projectsetup.consumercategoryid = null;
      projectsetup.electricityrate = 0;
    } else if (name === "consumercategoryid") {
      if (projectSetup.sanctionload > 20 && isResidentialCategory(value.label || "")) {
        dispatch(setRoofDetailsError({ ...error, consumercategoryid: "Residential property is unavailable above 20 kW" }));
        return;
      } else if (projectSetup.sanctionload > 0 && name === "consumercategoryid") {
        setIsLoading?.(true)
        let electricalRender = ['providerid', 'sanctionload', 'consumercategoryid']
        if (electricalRender.includes(name)) {
          debouncedGetElecticRate(projectsetup.sanctionload, projectsetup.providerid?.value, projectsetup.consumercategoryid?.value);
        }
      }
      dispatch(setFormProjectSetup(projectsetup));
      updateErrorFields([name, 'sanctionload']);
      return
    }
    let electricalRender = ['providerid', 'sanctionload', 'consumercategoryid']
    if (electricalRender.includes(name)) { debouncedGetElecticRate(projectsetup.sanctionload, projectsetup.providerid?.value, projectsetup.consumercategoryid?.value); }
    dispatch(setFormProjectSetup(projectsetup));
    updateErrorFields(errorFields);
  };

  type NewRoofType = keyof typeof ROOF_TYPE_UTILIZATION_FACTOR;
  const roofTypes: { label: string; value: NewRoofType }[] = Object.keys(ROOF_TYPE_UTILIZATION_FACTOR).map((key) => ({ label: key, value: key as NewRoofType, }));

  // const roofTypes = [{ label: "RCC Flat", value: "RCC Flat" }, { label: "Metal Sheet", value: "Metal Sheet" }, { label: "Hybrid", value: "Hybrid" }] as NewRoofType[];
  // const roofTypes = [{ label: "RCC Flat", value: "RCC Flat" }, { label: "Metal Sheet", value: "Metal Sheet" }, { label: "Hybrid", value: "Hybrid" }] as RoofType[];
  const gridTypes = [{ label: "On Grid", value: "On Grid" }, { label: "Off Grid", value: "Off Grid" }, { label: "Hybrid", value: "Hybrid" }] as GridTypeOption[];

  // useEffect(() => {
  //   if (selected_project !== null) return;
  //   if (obsArea) {
  //     let usearea = obsArea
  //     if (is3ddata) {
  //       usearea = useableArea!
  //     }
  //     // debugger
  //     if (is3ddata) {
  //       dispatch(setFormProjectSetup({ ...projectSetup, useablearea: parseFloat(usearea), totalroofarea: parseFloat(obsArea), projecttype: { label: 'Hybrid', value: 'Hybrid' } as RoofType, state: regionName, country: countryName! }));
  //     } else {
  //       dispatch(setFormProjectSetup({ ...projectSetup, useablearea: parseFloat(usearea), totalroofarea: parseFloat(obsArea), projecttype: null, state: regionName, country: countryName! }));
  //     }
  //   };
  //   if (polygonDrawn.length && obsArea) {
  //     getCityFromCoordinates(lng!, lat!).then((city: string) => {
  //       dispatch(setCreatedId(newgeneratedId(city)));

  //       fetchCompleteAddress(lat, lng, true).then((ele: any) => {
  //         setTimeout(() => {
  //           const inp = globalLayers.searchWidgetInput;
  //           if (inp && inp.container.querySelector(".esri-search__input") && ele) {
  //             inp.container.querySelector(".esri-search__input").value = ele;
  //           }
  //         }, 2000);

  //         let usearea = obsArea
  //         if (is3ddata) {
  //           usearea = useableArea!
  //         }
  //         if (is3ddata) {
  //           dispatch(setFormProjectSetup({ ...projectSetup, useablearea: parseFloat(usearea), totalroofarea: parseFloat(obsArea), projecttype: { label: 'Hybrid', value: 'Hybrid' } as RoofType, state: regionName, country: countryName! }));
  //         } else {
  //           dispatch(setFormProjectSetup({ ...projectSetup, address: ele, useablearea: parseFloat(usearea), totalroofarea: parseFloat(obsArea), projecttype: null, state: regionName, country: countryName! }));
  //         }
  //       })
  //     });
  //   }
  // }, [polygonDrawn, address, obsArea]);


  const [handleSubAccordian, setHandleSubAccordian] = useState(true)
  const [openSubAccordian, setOpenSubAccordian] = useState({
    roofConfirmation: true,
    electricityConsumption: true,
    utilityTariff: true,
    reviewSubmit: true
  });

  // console.log("Status project     --->>>>     ",(selected_project?.consumer_subprojectstatus ?? 0) >= 3 , selected_project?.consumer_subprojectstatus)

  return (
    <div className="">
      <div className="grid grid-cols-1 gap-x-2 gap-y-2">
        {step === 1 && <>
          {/* <Accordion  isOpen={handleSubAccordian} title={"Roof Confirmation"} onToggle={() => setHandleSubAccordian(!handleSubAccordian)}  maxh="48vh" height="47vh" > */}
          <Accordion childrenPaddingYOff isOpen={openSubAccordian.roofConfirmation} title={"Roof Confirmation"} onToggle={() => setOpenSubAccordian(prev => ({ ...prev, roofConfirmation: !prev.roofConfirmation }))} maxh="54vh" height="fit-content" >
            <Input id={"Project Name"} label={`Site name`} name={"projectname"} error={error?.projectname} value={projectSetup.projectname} type={"text"}
              onChange={handleChange} disabled={selected_project?.iscompleted} helpertext="Name used in proposal & reports" />

            <Input id={"Estimated Total Roof Area"} label={`Total roof size`} isRequired name={"totalroofarea"} error={error?.totalroofarea} value={projectSetup.totalroofarea.toString()} helpertext="Calculated from your selected roof boundary"
              type={"number"} onChange={handleChange} disabled={isWithRoof || selected_project?.iscompleted} suftext="sq m" maxLength={5} max={projectSetup.totalroofarea > 99 ? String(MAX_ROOF_AREA) : ""} />

            <div className="relative top-[2px]">
              <ReactSelect error={error.projecttype} isrequired onChange={handleChange} isSearchable={false} options={formatReactSelectOptions(roofTypes, { labelKey: "label", valueKey: "value" }, false)} menuPlacement="top"
                value={(projectSetup?.projecttype && Object.keys(projectSetup?.projecttype).length > 0) && projectSetup?.projecttype?.label !== null ? projectSetup?.projecttype : null} closeMenuOnSelect={true} labelname='Roof type' name='projecttype' placeholder='Select an option'
                disabled={selected_project?.iscompleted || is3ddata} infoDetails={"contentlist.content2"} helperText="Affects mounting structure & cost" />
              {/* <span className={`helper-box1 opacity-100`}>{"Affects mounting structure & cost"}</span> */}
            </div>
            <div className="p-0.5"></div>

            <Input tooltipContent={"Roof space considered"} id={"Estimated Total Usable Area"} label={"Solar install area"} isRequired name={"useablearea"} error={error?.useablearea} value={is3ddata ? useableArea! : (projectSetup?.useablearea || 0 > 0) ? projectSetup?.useablearea?.toFixed(2) : projectSetup?.totalroofarea?.toFixed(2)}
              type={"number"} onChange={handleChange} disabled={true} suftext="sq m" helpertext="Area available after shadows & access space" />
            <div className=""></div>
            <div className="p-4"></div>
            {/* <ReactToolTip className="max-w-[25vw]" isClickable Side="LSB" place="right" id={"electricityrateTooltip"} content={showMoreToolTip.electricityratetooltip} /> */}
          </Accordion>
        </>}

        {step === 2 && <>
          {/* <Accordion  isOpen={handleSubAccordian} title={"Electricity Consumption"} onToggle={() => setHandleSubAccordian(!handleSubAccordian)}  maxh="35vh" > */}
          <Accordion parentOverflowY="visible" childrenOverflowY="scroll" height="30vh" isOpen={openSubAccordian.electricityConsumption} title={"Electricity Consumption"} overflowY={"visible"} onToggle={() => setOpenSubAccordian(prev => ({ ...prev, electricityConsumption: !prev.electricityConsumption }))} maxh="34vh" >
            <Input isRequired smpadding id={"Sanctioned Load"} label={"Connected load (AC)"} error={error?.sanctionload} onKeyPress={validateNumberOnlyInput} name={"sanctionload"} value={projectSetup.sanctionload ? projectSetup.sanctionload.toString() : ""} type="number" onChange={handleChange} disabled={(selected_project?.consumer_subprojectstatus ?? 0) >= 3} suftext="kW" maxLength={4} helpertext={isAboveSuggestedLoad
              ? `Suggested load for this roof area is up to ${suggestedMaxLoad} kW`
              : "Total sanctioned load on your electricity meter "} />
            <div className="p-1"></div>
            <Input disabled={selected_project?.iscompleted} suftext="units" /* max='15000' */ /*max={maxMonthlyUnit ?? 15000}*/ id={"monthlyUnit"} label={"Average monthly units"} name={"monthlyunit"} value={projectSetup?.monthlyunit!.toString()} type="text" onChange={handleChange} helpertext="Most homes: 200–800 units/month" /* Indian */ />

            <div className="relative top-[2px]"> {/* Grid Type  */}
              <ReactSelect error={error.gridtype} isrequired onChange={handleChange} isSearchable={false} options={formatReactSelectOptions(gridTypes, { labelKey: "label", valueKey: "value" }, false)} menuPlacement="bottom"
                value={(projectSetup?.gridtype && Object.keys(projectSetup?.gridtype).length > 0) && projectSetup?.gridtype?.label !== null ? projectSetup?.gridtype : null} closeMenuOnSelect={true} labelname='Grid type' name='gridtype' placeholder='Select an option'
                disabled={true} infoDetails={"contentlist.content2"} />
              {/* <span className={`helper-box1 opacity-100`}>{"Affects mounting structure & cost"}</span>   disabled={selected_project?.iscompleted} */}
            </div>
            {/* <div className="p-3"></div> */}
          </Accordion>
        </>}

        {step === 3 && <>
          {/* <Accordion  isOpen={handleSubAccordian} title={"Utility & Tariff"} onToggle={() => setHandleSubAccordian(!handleSubAccordian)}  maxh="43vh" > */}
          <Accordion childrenPaddingYOff isOpen={openSubAccordian.utilityTariff} title={"Utility & Tariff"} onToggle={() => setOpenSubAccordian(prev => ({ ...prev, utilityTariff: !prev.utilityTariff }))} height="fit-content" maxh="46vh" >
            <Input isRequired id={"State/Province/Region"} label={`State/Province/Region`} name={"state"} /* value={countryName} */ value={projectSetup?.state ?? ""} error={""} type={"text"} onChange={() => { }} disabled={true} />
            {allDiscom.length > 0 && <>
              <ReactSelect isrequired menuPlacement={allDiscom.length > 2 ? "top" : "auto"} isSearchable={false} onChange={handleChange} options={formatReactSelectOptions(allDiscom, { labelKey: "providername", valueKey: "providerid" }, false)} value={projectSetup.providerid!} closeMenuOnSelect={true} key='providerid' labelname='Your electricity company' name='providerid' placeholder="Select an option"
                disabled={selected_project?.iscompleted} error={error.providerid} helperText="You can check this on your latest bill" />
              <ReactSelect toolTipIcon={true} istooltipContent tooltipContent={
                <div className="text-xs leading-relaxed">
                  <p className="mb-1 font-medium">Property type reflects roof type.</p>
                  <ul className="list-disc pl-3 space-y-0.5">
                    <li>Residential property is unavailable above 20 kW.</li>
                  </ul>
                </div>
              } isrequired isLoading={isLoadingProvider === "loading"} menuPlacement="top" isSearchable={false} isRequired onChange={handleChange} options={formatReactSelectOptions(filteredProviderType, { labelKey: "consumercategoryname", valueKey: "consumercategoryid" }, false)} value={(projectSetup.consumercategoryid && Object.keys(projectSetup.consumercategoryid).length > 0) ? projectSetup.consumercategoryid : null}
                closeMenuOnSelect={true} key='consumercategoryid' labelname='Property type ' placeholder="Select an option" name='consumercategoryid' disabled={selected_project?.iscompleted || projectSetup.providerid === null} error={error.consumercategoryid} helperText="Based on DISCOM slab" />
            </>}
            <Input isRequired id={"electricityrate"} suftext={`${getCurrencyLabel(user.country_mstr)}`} label="Your current per-unit bill rate" name={"electricityrate"} value={rateDraft ?? (Number.isFinite(projectSetup.electricityrate) ? String(projectSetup.electricityrate) : "")} onBlur={() => setRateDraft(null)} type={"text"} onChange={handleChange} disabled={selected_project?.iscompleted || electricRateLoading} error={error.electricityrate} helpertext="You can check this on your latest bill" onKeyDown={blockKeys(["e", "E", "+", "-"])} />
            {/* <Input  tooltipContent={<IconInfo1 />} id={"electricityrate"} suftext={`${getCurrencyLabel(user.country_mstr)}`} label="Your current per-unit bill rate" name={"electricityrate"} value={isNaN(projectSetup?.electricityrate) ? "0" : projectSetup?.electricityrate?.toString() ?? "0"} type={"text"} onChange={handleChange} disabled={selected_project?.iscompleted} error={error.electricityrate} /> */}
            <div className="p-4"></div>
          </Accordion>
        </>}
        {/* <ReactToolTip className="max-w-[25vw]" isClickable Side="LSB" place="right" id={"financialsavingstooltip"} content={showMoreToolTip.financialsavingstooltip} /> */}

        {step === 4 && <>
          {/* <Accordion  isOpen={handleSubAccordian} title={"Review & submit"} onToggle={() => setHandleSubAccordian(!handleSubAccordian)}  maxh="51vh" > */}
          <Accordion height="fit-content" isOpen={openSubAccordian.reviewSubmit} title={"Review & submit"} onToggle={() => setOpenSubAccordian(prev => ({ ...prev, reviewSubmit: !prev.reviewSubmit }))} maxh="46vh" >
            < SolarReviewComponent />
            <div className="p-3"></div>
          </Accordion>
        </>}

      </div>
    </div>
  );
};
export default memo(RoofDetails)
